import { useCallback, useState } from 'react'

// https://legacy.reactjs.org/docs/hooks-faq.html#how-can-i-measure-a-dom-node
export default function useMapRef() {
  const [map, setMap] = useState(null)
  const ref = useCallback((node) => {
    if (node !== null) {
      setMap(node)
    }
  }, [])
  return [map, ref]
}
